import { Box } from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Modal,
  Snackbar,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from 'src/Api';
import GooglePlaces from 'src/components/GooglePlaces';
import Iconify from 'src/components/Iconify';
import ExistingCustomerTable from 'src/components/home/ExistingCustomerTable';
import CloseIcon from '@mui/icons-material/Close';

const getTimeInMinutes = (time) => {
  if (!time) {
    return null;
  }

  const [hours, minutes] = time.split(':').map(Number);
  if (!Number.isInteger(hours) || !Number.isInteger(minutes)) {
    return null;
  }

  return hours * 60 + minutes;
};

const isDropoffAfterPickup = (pickup, dropoff) => {
  const pickupMinutes = getTimeInMinutes(pickup);
  const dropoffMinutes = getTimeInMinutes(dropoff);
  return pickupMinutes !== null && dropoffMinutes !== null && dropoffMinutes > pickupMinutes;
};

const getNextMinute = (time) => {
  const totalMinutes = getTimeInMinutes(time);
  if (totalMinutes === null) {
    return '';
  }

  const nextMinute = totalMinutes + 1;
  if (nextMinute >= 24 * 60) {
    return '';
  }

  const nextHours = String(Math.floor(nextMinute / 60)).padStart(2, '0');
  const nextMinutes = String(nextMinute % 60).padStart(2, '0');
  return `${nextHours}:${nextMinutes}`;
};

const AddCustomer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');
  const { service_id, sub_service_id, item, is_pickup } = location.state || {};

  const [customerName, setCustomerName] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerContact, setCustomerContact] = useState('');
  const [pickupTime, setPickupTime] = useState('');
  const [dropoffTime, setDropoffTime] = useState('');
  const minimumDropoffTime = getNextMinute(pickupTime);
  const pickupPickerValue = pickupTime ? dayjs(`2000-01-01T${pickupTime}`) : null;
  const dropoffPickerValue = dropoffTime ? dayjs(`2000-01-01T${dropoffTime}`) : null;
  const minimumDropoffPickerTime = minimumDropoffTime
    ? dayjs(`2000-01-01T${minimumDropoffTime}`)
    : undefined;
  const [loading, setloading] = useState(false);
  const [loadingEdit, setloadingEdit] = useState(false);

  const [address, setaddress] = useState('');
  const [destination, setDestination] = useState('');

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [existingModal, setexistingModal] = useState(false);

  useEffect(() => {
    if (item) {
      setloadingEdit(true);
      setCustomerName(item?.customer_name);
      setCustomerEmail(item?.email);
      setCustomerContact(item?.contact);
      setPickupTime(item?.pickup_time?.slice(0, 5) || '');
      setDropoffTime(item?.dropoff_time?.slice(0, 5) || '');
      setaddress({
        address: item.pickup,
        lat: JSON.parse(item.pickup_lat),
        lon: JSON.parse(item.pickup_lon)
      });
      setDestination({
        address: item.dropoff,
        lat: JSON.parse(item.dropoff_lat),
        lon: JSON.parse(item.dropoff_lon)
      });
      setloadingEdit(false);
    }
  }, [item]);

  const handleSaveContact = () => {
    setloading(true);

    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    item?.id && formData.append('id', item?.id);
    formData.append('customer_name', customerName);
    formData.append('contact', customerContact);
    formData.append('email', customerEmail);
    formData.append('service_id', service_id);
    formData.append('sub_service_id', sub_service_id);
    formData.append('pickup_time', pickupTime);
    formData.append('dropoff_time', dropoffTime);

    address && formData.append('pickup', address?.address); // Required
    address && formData.append('pickup_lat', address?.lat); // Required
    address && formData.append('pickup_lon', address?.lon); // Required

    destination && formData.append('dropoff', destination?.address); // Required
    destination && formData.append('dropoff_lat', destination?.lat); // Required
    destination && formData.append('dropoff_lon', destination?.lon); // Required

    fetch(api.save_service_details, {
      headers: myHeaders,
      body: formData,
      method: 'POST'
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setTimeout(() => {
            navigate(-1);
          }, 2000);
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          console.error('Error:', result.message);
          setTimeout(() => {
            handleSnackbarClose();
          }, 2000);
        }
        setloading(false);
      })
      .catch((error) => {
        console.error('Fetch error:', error);
        setloading(false);
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const exceptThisSymbols = ['e', 'E', '+', '-', '.'];

  const handleCloseModal = () => {
    setexistingModal(false);
  };

  return (
    <Box>
      <Box sx={{ flexWrap: 'nowrap', padding: '0px 15px 0px 15px' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center">
            <IconButton
              style={{
                marginRight: 12,
                height: 40,
                width: 70,
                borderRadius: 5,
                backgroundColor: 'rgba(249, 0, 1,0.1)'
              }}
              onClick={() => navigate(-1)}
            >
              <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#f90001' }} />
            </IconButton>

            <Typography variant="h4" sx={{ color: '#f90001' }}>
              {item ? 'Edit Customer' : 'Add Customer'}
            </Typography>
          </Stack>
          <Stack>
            <Button
              variant="contained"
              sx={{ alignSelf: 'end', fontSize: 11 }}
              onClick={() => {
                setexistingModal(true);
              }}
            >
              Existing Customer
            </Button>
          </Stack>
        </Stack>
        <Modal
          open={existingModal}
          onClose={handleCloseModal}
          aria-labelledby="spring-modal-title"
          aria-describedby="spring-modal-description"
          style={{
            display: 'flex',
            height: '100%',
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Box
            sx={{
              width: '80%',
              height: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              padding: 2,
              border: '2px solid',
              borderColor: '#f00001',
              borderRadius: 0.5
            }}
          >
            <Box display={'flex'} justifyContent={'flex-end'} mr={3} alignItems="center">
              <IconButton onClick={handleCloseModal} edge="end">
                <CloseIcon />
              </IconButton>
            </Box>
            <ExistingCustomerTable
              customerdata={{
                serviceid: service_id,
                subserviceid: sub_service_id
              }}
              getdata={(e) => {
                console.log('console.log ', e);
                setCustomerName(e.name);
                setCustomerEmail(e.email);
                setCustomerContact(e.contact);
              }}
              onclick={handleCloseModal}
            />
          </Box>
        </Modal>
        {!loadingEdit && (
          <>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Grid container mt={2}>
                <Grid container spacing={2} mb={2}>
                  <Grid item spacing={2} xs={12} sm={6}>
                    <TextField
                      label="Customer Name"
                      name="name"
                      fullWidth
                      value={customerName}
                      onChange={(e) => {
                        if (e.target.value.length <= 50) {
                          setCustomerName(e.target.value);
                        }
                      }}
                      className="custom-textfield"
                    />
                  </Grid>

                  <Grid item spacing={2} xs={12} sm={6}>
                    <TextField
                      label="Customer Email"
                      name="email"
                      fullWidth
                      value={customerEmail}
                      onChange={(e) => {
                        if (e.target.value.length <= 50) {
                          setCustomerEmail(e.target.value);
                        }
                      }}
                      className="custom-textfield"
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2} mb={2}>
                  <Grid item spacing={2} xs={12} sm={6}>
                    <TextField
                      label="Customer Contact"
                      name="contactNumber"
                      fullWidth
                      value={customerContact}
                      onChange={(e) => {
                        if (e.target.value.length <= 20) {
                          setCustomerContact(e.target.value); // Only update if length is <= 100
                        }
                      }}
                      className="custom-textfield"
                      onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                      type="number"
                    />
                  </Grid>
                </Grid>

                {is_pickup == 1 && (
                  <Grid container spacing={2} mb={2}>
                    <Grid item xs={12} sm={9} md={10} lg={10} xl={10}>
                      <GooglePlaces
                        width="100%"
                        onResult={(val) => {
                          setaddress(val);
                        }}
                        placeholder={'Pickup'}
                        regions={true}
                        address={address ? address?.address : item?.pickup}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} md={2} lg={2}>
                      <MobileTimePicker
                        label="Pickup Time"
                        value={pickupPickerValue}
                        onChange={(value) => {
                          let selectedPickupTime = pickupTime;
                          if (value === null) {
                            selectedPickupTime = '';
                          } else if (value.isValid()) {
                            selectedPickupTime = value.format('HH:mm');
                          }
                          setPickupTime(selectedPickupTime);
                          if (
                            dropoffTime &&
                            !isDropoffAfterPickup(selectedPickupTime, dropoffTime)
                          ) {
                            setDropoffTime('');
                          }
                        }}
                        ampm
                        minutesStep={1}
                        slotProps={{
                          textField: {
                            name: 'pickup_time',
                            fullWidth: true,
                            className: 'custom-textfield'
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                )}

                {is_pickup == 1 && (
                  <Grid container spacing={2} mb={2}>
                    <Grid item xs={12} sm={9} md={10} lg={10} xl={10}>
                      <GooglePlaces
                        width="100%"
                        onResult={(val) => {
                          setDestination(val);
                        }}
                        placeholder={'Dropoff'}
                        regions={true}
                        address={destination ? destination?.address : item?.dropoff}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} md={2} lg={2}>
                      <MobileTimePicker
                        type="time"
                        label="Dropoff Time"
                        value={dropoffPickerValue}
                        onChange={(value) => {
                          if (value === null) {
                            setDropoffTime('');
                          } else if (value.isValid()) {
                            setDropoffTime(value.format('HH:mm'));
                          }
                        }}
                        disabled={!minimumDropoffTime}
                        minTime={minimumDropoffPickerTime}
                        ampm
                        minutesStep={1}
                        slotProps={{
                          textField: {
                            name: 'dropoff_time',
                            fullWidth: true,
                            className: 'custom-textfield'
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </LocalizationProvider>
            <Box display="flex" justifyContent="flex-end" mt={2}>
              <LoadingButton
                onClick={() => {
                  if (is_pickup == 1) {
                    if (!pickupTime) {
                      setSnackbarOpen(true);
                      setSnackbarMessage('Pickup time is required.');
                      setSnackbarSeverity('error');
                      return;
                    }

                    if (!isDropoffAfterPickup(pickupTime, dropoffTime)) {
                      setSnackbarOpen(true);
                      setSnackbarMessage('Dropoff time must be later than pickup time.');
                      setSnackbarSeverity('error');
                      return;
                    }

                    // Check if address and destination are the same
                    if (address && destination && address.address == destination.address) {
                      setSnackbarOpen(true);
                      setSnackbarMessage('Pickup and Dropoff locations cannot be the same.');
                      setSnackbarSeverity('error');
                      return; // Stop execution if the same
                    }

                    // Check if address is null
                    if (!address) {
                      setSnackbarOpen(true);
                      setSnackbarMessage('Pickup address is required.');
                      setSnackbarSeverity('error');
                      return; // Stop execution if address is missing
                    }

                    // Check if destination is null
                    if (!destination) {
                      setSnackbarOpen(true);
                      setSnackbarMessage('Dropoff destination is required.');
                      setSnackbarSeverity('error');
                      console.log('Destination is null');
                      return; // Stop execution if destination is missing
                    }

                    // All conditions satisfied, call the function
                    console.log('Calling handleSaveContact after validation');
                    handleSaveContact();
                    return; // Ensure no duplicate calls
                  }

                  // If is_pickup is not 1, directly call the function
                  console.log('Calling handleSaveContact without validation');
                  handleSaveContact();
                }}
                color="primary"
                variant="contained"
                loading={loading}
                sx={{ fontSize: 12 }}
              >
                Save
              </LoadingButton>
            </Box>
          </>
        )}

        {loadingEdit && <CircularProgress />}

        <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
};

export default AddCustomer;
